<nav class="navbar">
  <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
    <i class="feather icon-menu"></i>
  </a>
  <div class="navbar-content">
    <ul class="navbar-nav">
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button">
          <img alt="language-image" class="wd-20 me-1" [src]="imageSrc" />
          <span
            [ngClass]="{ Spanish: flag == 'es', English: flag == 'us' }"
            class="fw-bold ms-1 me-1 d-none d-md-inline-block"
          ></span>
        </a>
        <div ngbDropdownMenu aria-labelledby="languageDropdown" id="languages">
          <a ngbDropdownItem class="py-2" (click)="changeLang('us')">
            <img src="assets/images/flags/us.svg" class="wd-20 me-1" title="us" alt="us" />
            <span class="ms-1"> English </span></a
            >
            <a ngbDropdownItem class="py-2" (click)="changeLang('es')">
              <img src="assets/images/flags/es.svg" class="wd-20 me-1" title="es" alt="es" />
              <span class="ms-1"> Spanish </span></a
              >
            </div>
          </li>

          <li class="nav-item nav-profile" ngbDropdown>
            <a class="nav-link" ngbDropdownToggle id="profileDropdown">
              @if (imageProfile) {
                <img
                  class="wd-30 ht-30 rounded-circle"
                  [src]="imageProfile"
                  alt="profile"
                  />
              } @else {
                <img
                  class="wd-30 ht-30 rounded-circle"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWQbhaVzujIXlB_SXYPp2AnNHMvvcANRUZwQ&usqp=CAU"
                  alt="profile"
                  />
                }
              </a>
              <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
                <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
                  <div class="mb-3">
                    @if (imageProfile) {
                      <img
                        class="wd-80 ht-80 rounded-circle"
                        [src]="imageProfile"
                        alt=""
                        />
                    } @else {
                      <img
                        class="wd-80 ht-80 rounded-circle"
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWQbhaVzujIXlB_SXYPp2AnNHMvvcANRUZwQ&usqp=CAU"
                        alt="profile"
                        />
                      }
                    </div>
                    <div class="text-center">
                      <p class="tx-16 fw-bolder">{{ username | titlecase }}</p>
                      <p class="tx-12 text-muted">{{ email }}</p>
                    </div>
                  </div>
                  <ul class="list-unstyled p-1">
                    <li class="dropdown-item py-2">
                      <a [routerLink]="['user/profile/show/', idUser]" class="d-flex text-body ms-0">
                        <i class="feather icon-user me-2 icon-md"></i>
                        <span>{{ "Profile.Title" | translate }}</span>
                      </a>
                    </li>
                    <li class="dropdown-item py-2">
                      <a href="" (click)="onLogout($event)" class="d-flex text-body ms-0">
                        <i class="feather icon-log-out me-2 icon-md"></i>
                        <span>{{ "Profile.Log_Out" | translate }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </nav>
